export default {
  INVALID_FLASH_VERSION     : 'Error loading player: Flash version must be 11.2 or greater',
  UNSUPPORTED_FILE_ENCODING : 'Error loading media: File could not be played'
};



// WEBPACK FOOTER //
// ./src/errorCodes.js